class HttpError extends Error {
    constructor(
        public readonly message: string,
        public readonly status: number,
        public readonly body: any = null
    ) {
        super(message);

        // Set the prototype explicitly
        Object.setPrototypeOf(this, HttpError.prototype);

        // Set the error name
        this.name = this.constructor.name;

        // Capture the stack trace if available
        if (typeof (Error as any).captureStackTrace === 'function') {
            (Error as any).captureStackTrace(this, this.constructor);
        } else {
            this.stack = new Error(message).stack;
        }
    }
}

export default HttpError;
